import styled from 'styled-components'
import {  Modal } from 'antd';

export const ModalStyle = styled(Modal)`
  .modal-footer{
    text-align: center;
  }
`

export default null;